<template>
    <div class="device" @mouseenter="disabled ? '' : showPopup()"
        @mouseleave="isFocused || isShowAllNames || disabled ? '' : hidePopup()"
        :class="{ 'device--focus': isFocused, disabled: disabled }">
        <div class="device__switch">
            <div class="device__player-number">
                <div class="device__playerColor" :style="{ backgroundColor: player.deviceColor }"></div>
                {{ player.playerNumber }}</div>
            <i class="fas fa-heart device__switch-icon" :class="{
                'device__switch-icon--active': awardedDeviceIds.includes(
                    device.id
                )
            }" @click="disabled ? '' : UPDATE_AWARDED_DEVICES(device.id)"></i>
        </div>
        <div class="device__info">
            <div @click="disabled ? '' : onDeviceClick()">
                <div class="device__info-name">
                    <span v-if="player.firstname">{{ player.firstname }}</span>&nbsp;
                    <span v-if="player.lastname">{{ player.lastname }}</span>
                    <span v-else-if="player.specialName">{{ player.specialName }}</span>
                </div>
            </div>
            <div v-if="!player.specialName && !isPlaybackReady" class="device__info-track" :class="{
                'device__info-track--right':
                    player.specialName || isPlaybackReady,
            }">
                <template v-if="!disabled">
                    <idle-status :deviceId="device.id" />
                    <gps-status :device="device.id" />
                    <!-- <p
                        v-if="!player.specialName && !isPlaybackReady"
                        @click="disabled ? '' : refreshDistance()"
                    >
                        {{ Number.parseInt(deviceDistance / 1000) }} km
                        <i
                            class="fas fa-sync-alt f12"
                            :class="{ 'refresh-animation': isFetchingDistance }"
                        ></i>
                    </p> -->
                    <!-- <p></p> -->
                    <!-- <div v-if="
                        !player.specialName &&
                        competition.startedTime < now()
                    " class="d-flex pointer" @click="disabled ? '' : downloadGPX()">
                        GPX
                        <img class="mal4" src="../assets/images/file-download-black.svg" alt />
                    </div> -->
                </template>
                <template v-else>
                    <p>Uczestnik poza trasą</p>
                </template>
                <battery-status :device="device.id" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
    UPDATE_AWARDED_DEVICES,
    READ_ROUTE,
    READ_SUMMARY_DEVICE,
} from '@/store/actions.type'
import { SET_FOCUS_DEVICE_ID } from '@/store/mutations.type'
import moment from 'moment'
import BatteryStatus from '@/components/device/BatteryStatus'
import GpsStatus from './device/GpsStatus.vue'
import IdleStatus from './device/IdleStatus.vue'
export default {
    components: {
        BatteryStatus,
        IdleStatus,
        GpsStatus,
    },
    data() {
        return {
            isFetchingDistance: false,
        }
    },
    props: {
        device: {
            type: Object,
            required: true,
        },
        player: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'awardedDeviceIds',
            'focusDeviceId',
            'markers',
            'devicesSummary',
            'classifications',
            'competitions',
            'isPlaybackReady',
            'playbackMarkers',
            'isShowAllNames',
        ]),
        isFocused() {
            return this.focusDeviceId == this.device.id
        },
        deviceDistance() {
            return this.devicesSummary[this.device.id].distance
        },

        classification() {
            if (this.player.specialName) {
                return null
            }
            return this.classifications[this.player.classification]
        },
        competition() {
            if (this.classification) {
                return this.competitions[this.classification.competition]
            }
            return null
        },
        playbackMarker() {
            return this.playbackMarkers[this.device.id]
        },
        liveMarker() {
            return this.markers[this.device.id]
        },
    },
    methods: {
        ...mapActions({
            UPDATE_AWARDED_DEVICES,
            READ_ROUTE,
            READ_SUMMARY_DEVICE,
        }),
        ...mapMutations({
            SET_FOCUS_DEVICE_ID,
        }),
        now() {
            return moment()
        },
        async refreshDistance() {
            this.isFetchingDistance = true
            let fromTime = this.competition.startedTime.clone()
            await this.READ_SUMMARY_DEVICE({
                from: fromTime.subtract(2, 'h').toISOString(),
                to: new Date().toISOString(),
                deviceId: this.device.id,
            })
            this.isFetchingDistance = false
        },
        async downloadGPX() {
            let fromTime = this.competition.startedTime.clone()
            let query = {
                from: fromTime.subtract(2, 'h').toISOString(),
                to: new Date().toISOString(),
                deviceId: this.device.id,
            }
            let route = await this.READ_ROUTE(query)
            let blob = new Blob([route], { type: 'text/plain' })
            let element = document.createElement('a')
            element.download = `${this.player.firstname} ${this.player.lastname}.gpx`
            element.href = window.URL.createObjectURL(blob)
            element.click()
        },
        onDeviceClick() {
            if (this.focusDeviceId == this.device.id) {
                this.SET_FOCUS_DEVICE_ID(null)
            } else {
                this.SET_FOCUS_DEVICE_ID(this.device.id)
            }
            this.$emit('changeFocus')
        },
        showPopup() {
            if (this.isPlaybackReady) {
                this.playbackMarker.openTooltip()
            } else {
                this.liveMarker.openPopup()
            }
        },
        hidePopup() {
            if (this.isPlaybackReady) {
                this.playbackMarker.closeTooltip()
            } else {
                this.liveMarker.closePopup()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.disabled {
    opacity: 0.6;
}

.device {
    border-radius: 4px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1), 0 0 2px 0 rgba(55, 71, 79, 0.2);
    background-color: $white;
    display: flex;
    padding: 10px 8px;
    line-height: 1.43;

    &:hover:not(.device--focus):not(.disabled) {
        background-color: $light-grey;
    }

    &--focus {
        background-color: #c6c6c6;
    }

    &__info {
        width: 100%;
        padding-left: 10px;
        cursor: pointer;

        &-name {
            max-width: 100%;
        }

        &-track {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            margin-top: 10px;
        }

        &-track--right {
            display: flex;
            justify-content: flex-end;
        }
    }
    &__playerColor {
        border-radius: 100%;
        width: 6px;
        height: 6px;
        margin-right: 4px;
    }

    &__player-number {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
    }

    &__switch {
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        display: flex;
        gap: 8px;

        &-icon {
            font-size: 22px;
            color: #dfdfdf;

            &--active {
                color: #ff3d00
            }
        }

        &-btn {
            width: 40px;
            height: 24px;
            background-color: $pale-grey;
            border-radius: 12px;
            position: relative;
            cursor: pointer;
            transition: all 0.3s;

            &::after {
                transition: all 0.3s;
                content: '';
                position: absolute;
                top: 2px;
                left: 2px;
                width: 20px;
                height: 20px;
                border-radius: 12px;
                display: inline-block;
                background-color: $white;
                box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1),
                    0 0 2px 0 rgba(55, 71, 79, 0.2);
            }

            &--active {
                background-color: $red-orange;
                opacity: 1;

                &::after {
                    left: 18px;
                }
            }
        }
    }
}

@keyframes roller {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.refresh-animation {
    animation: roller 0.6s infinite;
}
</style>
